import { ProjectFetch } from '@roi/common/services/fetches/project.fetch';
import {
  selectSubDistrictsLoading,
  selectWaterUse,
} from './../selector/master.selector';
import { PlantFetch } from '@roi/common/services/fetches/plant.fetch';
import { YearFetch } from '@roi/common/services/fetches/water-allocation-years.fetch';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MasterFetch } from '../../../services/fetches/master.fetch';
import { Injectable, inject } from '@angular/core';
import * as ProvinceActions from '../actions/province.action';
import * as DistrictActions from '../actions/district.action';
import * as SubDistrictActions from '../actions/sub-district.action';
import * as MasterActions from '../actions/master.action';

import { catchError, map, mergeMap, of } from 'rxjs';
import { ActivityFetch } from '@roi/common/services/fetches/activity.fetch';
@Injectable()
export class MasterEffects {
  actions$ = inject(Actions);

  constructor(
    private masterFetch: MasterFetch,
    private yearFetch: YearFetch,
    private activityFetch: ActivityFetch,
    private plantFetch: PlantFetch,
    private projectFetch: ProjectFetch
  ) {}

  loadProvinces$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProvinceActions.loadProvinces),
      mergeMap(() =>
        this.masterFetch.provinces().pipe(
          map((res) =>
            ProvinceActions.loadProvincesSuccess({
              provinces: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(ProvinceActions.loadProvincesFailure({ error }))
          )
        )
      )
    )
  );

  loadDistricts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DistrictActions.loadDistricts),
      mergeMap((action) =>
        this.masterFetch.districts(action.provinceId).pipe(
          map((res) =>
            DistrictActions.loadDistrictsSuccess({
              districts: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(DistrictActions.loadDistrictsFailure({ error }))
          )
        )
      )
    )
  );
  loadSubDistricts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubDistrictActions.loadSubDistricts),
      mergeMap((action) =>
        this.masterFetch.subDistricts(action.districtId).pipe(
          map((res) =>
            SubDistrictActions.loadSubDistrictsSuccess({
              subDistricts: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(SubDistrictActions.loadSubDistrictsFailure({ error }))
          )
        )
      )
    )
  );
  loadYears$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadYears),
      mergeMap(() =>
        this.yearFetch.getByCriteria({ id: null }).pipe(
          map((res) =>
            MasterActions.SetYears({
              years: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(ProvinceActions.loadProvincesFailure({ error }))
          )
        )
      )
    )
  );
  loadWaterUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadWaterUse),
      mergeMap(() =>
        this.activityFetch.getByCriteria({}).pipe(
          map((res) =>
            MasterActions.SetWaterUse({
              waterUse: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(ProvinceActions.loadProvincesFailure({ error }))
          )
        )
      )
    )
  );
  loadlandUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadLandUse),
      mergeMap(() =>
        this.plantFetch.getByCriteria({}).pipe(
          map((res) =>
            MasterActions.SetLandUse({
              landUse: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(ProvinceActions.loadProvincesFailure({ error }))
          )
        )
      )
    )
  );
  loadIrrigationOffices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadIrrigationOffices),
      mergeMap(() =>
        this.masterFetch.irrigationOffices().pipe(
          map((res) =>
            MasterActions.SetIrrigationOffices({
              irrigationOffices: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(ProvinceActions.loadProvincesFailure({ error }))
          )
        )
      )
    )
  );
  loadProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadProjects),
      mergeMap((action) =>
        this.projectFetch
          .get({ irrigation_office_id: action.irrigation_office_id })
          .pipe(
            map((res) =>
              MasterActions.SetProjects({
                projects: res.payload || ([] as any),
              })
            ),
            catchError((error) =>
              of(ProvinceActions.loadProvincesFailure({ error }))
            )
          )
      )
    )
  );
  loadStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadStatus),
      mergeMap(() =>
        this.masterFetch.getWaterStatus().pipe(
          map((res) =>
            MasterActions.SetStatus({
              status: res.payload || ([] as any),
            })
          ),
          catchError((error) =>
            of(ProvinceActions.loadProvincesFailure({ error }))
          )
        )
      )
    )
  );
}
